module.exports = __webpack_public_path__ + "img/table.5f5a062a.png";